import { useState, useEffect } from 'react'
import { contactoService, type ContactoInfo } from '@/features/contacto/services/contacto.service'

export function useContacto() {
  const [contacto, setContacto] = useState<ContactoInfo | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    Promise.all([
      contactoService.obtener(),
      contactoService.obtenerImagenContacto().catch(() => null),
    ])
      .then(([data, imageUrl]) => {
        if (!cancelled && data) setContacto({ ...data, imageUrl: imageUrl ?? data.imageUrl })
        else if (!cancelled && !data) setContacto(null)
      })
      .catch(() => {
        if (!cancelled) setError('No se pudo cargar la información de contacto.')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => { cancelled = true }
  }, [])

  return { contacto, loading, error }
}
